export const ADMIN_EMAILS = [
  "shirlenedymock@mac.com",
  "shirlenedymock@gmail.com",
  "rdymock@gmail.com",
];
